<template>
  <section class="mt-4 border-top pt-3">
    <button class="btn btn-outline-primary" :disabled="carregando || salvando" @click="carregar">
      Regularizar aulas passadas
    </button>
    <div v-if="aberto" class="mt-3">
      <p>Registre o que realmente ocorreu em cada aula. A turma permanecerá com sua situação atual.</p>
      <p v-if="erro" class="alert alert-danger" role="alert">{{ erro }}</p>
      <p v-if="sucesso" class="alert alert-success" role="status">{{ sucesso }}</p>
      <p v-if="carregando" role="status">Consultando pendências...</p>
      <template v-else>
        <p v-if="!aulas.length && !erro">Não há aulas passadas pendentes de baixa.</p>
        <div v-if="aulas.length" class="table-responsive">
          <table class="table table-striped align-middle">
            <thead><tr><th>Aluno</th><th>Tipo</th><th>Data</th><th>Horário</th><th>Ações</th></tr></thead>
            <tbody>
              <tr v-for="aula in aulas" :key="chave(aula)">
                <td>{{ aula.aluno_nome || 'Vínculo a revisar' }}</td><td>{{ aula.tipo }}</td>
                <td>{{ aula.data_aula.split('-').reverse().join('/') }}</td><td>{{ aula.horario.slice(0,5) }}</td>
                <td>
                  <template v-if="podeRegistrar">
                    <button class="btn btn-success btn-sm me-2" :disabled="salvando" @click="regularizar(aula,true)">Compareceu</button>
                    <button class="btn btn-warning btn-sm me-2" :disabled="salvando" @click="regularizar(aula,false)">Faltou</button>
                  </template>
                  <router-link v-if="podeConsultar(aula)" :to="cadastro(aula)" class="btn btn-outline-secondary btn-sm" :class="{disabled:salvando}">
                    Consultar cadastro / cancelamento
                  </router-link>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <p v-if="aulas.length" class="text-muted">Se a aula foi cancelada, consulte o cadastro correspondente e use o fluxo de cancelamento existente. Não registre falta para representar cancelamento.</p>
      </template>
    </div>
  </section>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue';
import axios from '@/services/axios';
import { usePermissions } from '@/composables/usePermissions';
const props=defineProps({turmaId:{type:Number,required:true}});
const {fetchPermissions,hasPermission}=usePermissions();
const permissoesProntas=ref(false);
const podeRegistrar=computed(()=>permissoesProntas.value && hasPermission('registrar_chamada'));
const aulas=ref([]), aberto=ref(false), carregando=ref(false), salvando=ref(false), erro=ref(''), sucesso=ref('');
const chave=a=>[a.tipo,a.id,a.data_aula,a.horario].join('|');
const podeConsultar=a=>permissoesProntas.value && hasPermission(a.tipo==='Experimental'?'detalhar_prospeccao':a.tipo==='Avulso'?'detalhar_aulas_avulsas':'detalhar_aulas_reposicao');
const cadastro=a=>a.tipo==='Experimental'?`/operacional/prospeccao/${a.cadastro_id}/detalhar`:a.tipo==='Avulso'?`/operacional/aulas-avulsas/${a.cadastro_id}/detalhar`:`/operacional/aulas-reposicao/${a.cadastro_id}/detalhar`;
async function carregar() {
  aberto.value=true;carregando.value=true;erro.value='';
  try {aulas.value=(await axios.get(`/cadastros/turmas/${props.turmaId}/pendencias-passadas`)).data.data;}
  catch(e){erro.value=e.response?.data?.error || 'Não foi possível consultar as pendências. Tente novamente.';}
  finally{carregando.value=false;}
}
async function regularizar(aula,presenca) {
  if(salvando.value || !podeRegistrar.value)return;
  const acao=presenca?'Compareceu':'Faltou';
  if(!window.confirm(`Registrar ${acao} para ${aula.aluno_nome} na aula de ${aula.data_aula.split('-').reverse().join('/')} às ${aula.horario.slice(0,5)}?`))return;
  salvando.value=true;erro.value='';sucesso.value='';
  try {
    await axios.post(`/cadastros/turmas/${props.turmaId}/regularizar-aula`,{tipo:aula.tipo,id:aula.id,data_aula:aula.data_aula,horario:aula.horario,presenca});
    await carregar();sucesso.value='Aula regularizada. A situação da turma foi preservada.';
  }catch(e){erro.value=e.response?.data?.error || 'Não foi possível regularizar. Atualize a lista antes de tentar novamente.';}
  finally{salvando.value=false;}
}
onMounted(async()=>{await fetchPermissions();permissoesProntas.value=true;});
</script>
